import { Controller } from "@hotwired/stimulus"

// Controller for the collapsible search panel
export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    console.log("SearchPanelController connected!")
    console.log("Connected to element:", this.element)
    console.log("Has content target:", this.hasContentTarget)
    console.log("Has icon target:", this.hasIconTarget)
    
    // Set initial state - icon should point down when content is hidden
    if (this.hasContentTarget && this.hasIconTarget) {
      const isHidden = this.contentTarget.classList.contains("hidden");
      this.iconTarget.classList.toggle("rotate-180", !isHidden);
    }
  }

  toggle(event) {
    console.log("toggleIcon() called")
    if (event) event.preventDefault();
    
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden");
      
      if (this.hasIconTarget) {
        const isHidden = this.contentTarget.classList.contains("hidden");
        this.iconTarget.classList.toggle("rotate-180", !isHidden);
      }
    }
  }
}